@file:Suppress("DEPRECATION")

package org.example.newportfolio.components.sections.start.components

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

// Container dimensions for the hero photo + spotlight halo.
//
// Width:height ratios sit close to the recropped cutout's natural aspect
// (≈0.60) so `object-fit: contain` doesn't leave dead horizontal space
// flanking the subject. Each breakpoint is sized noticeably larger than
// the previous version — the user's design feedback was that the photo
// felt small relative to the hero canvas, so we push it close to the
// `Smith` / `Joy Seno` reference proportions (figure occupies ~45–50%
// of the visible width on desktop).
val StartSectionImageStyle by ComponentStyle {
    Breakpoint.ZERO {
        // Trimmed from 400×240: at 240px the figure was 61-67% of a 360-393px
        // phone, crowding the title. 192px (~50% of width) gives premium
        // breathing room and a tighter stacked-hero rhythm. Aspect preserved.
        Modifier.height(320.px).width(192.px)   // 0.600 aspect
    }
    Breakpoint.SM {
        Modifier.height(380.px).width(228.px)   // 0.600
    }
    Breakpoint.MD {
        Modifier.height(620.px).width(370.px)   // 0.597
    }
    Breakpoint.LG {
        Modifier.height(720.px).width(430.px)   // 0.597
    }
    Breakpoint.XL {
        Modifier.height(840.px).width(500.px)   // 0.595
    }
}